import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { vectorConfigurationSelectors } from '../../reducers/vectorConfigurationSlice';
import {
  CaretTemporaryData,
  selectCaretTemporaryData,
  setCaretTemporaryData,
} from '../../reducers/zoomSlice';
import { CaretDirection } from '../types';
import { useAppSelector } from '../../reducers/rootReducer';

const useVectorCaretEffect = (
  zoomInCertainLevel: (temporaryData: CaretTemporaryData) => void,
  handler: (detail: { direction: CaretDirection }) => void,
) => {
  const dispatch = useDispatch();
  const caretTemporaryData = useAppSelector(selectCaretTemporaryData);
  const isVectorChartLoaded = useAppSelector(
    vectorConfigurationSelectors.selectIsVectorChartLoaded,
  );

  useEffect(() => {
    if (caretTemporaryData && isVectorChartLoaded) {
      zoomInCertainLevel(caretTemporaryData);
      dispatch(setCaretTemporaryData(null));
    }
  }, [caretTemporaryData, dispatch, zoomInCertainLevel, isVectorChartLoaded]);

  const callHandlerWithParam = useCallback(
    (event) => {
      event.stopImmediatePropagation();
      const { detail } = event;
      handler(detail);
    },
    [handler],
  );

  useEffect(() => {
    document.addEventListener('applyCaretClick', callHandlerWithParam);

    return () => {
      document.removeEventListener('applyCaretClick', callHandlerWithParam);
    };
  }, [callHandlerWithParam]);
};

export default useVectorCaretEffect;
